import { FC } from 'react';
import { BreakdownAudienceAverage } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceAverage';
import { MessageMediumTab } from 'modules/intelligentInsights/frequencyOptimization/types';
import { BreakdownAudienceEngagement } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceEngagement';
import { BreakdownAudienceSize } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceSize';
import { AudienceLiftWrapper } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceLift.styles';

export type BreakdownAudienceLiftProps = {
  messageMedium: MessageMediumTab;
};

export const BreakdownAudienceLift: FC<BreakdownAudienceLiftProps> = ({ messageMedium }) => {
  return (
    <AudienceLiftWrapper>
      <BreakdownAudienceSize messageMedium={messageMedium} />
      <BreakdownAudienceAverage messageMedium={messageMedium} />
      <BreakdownAudienceEngagement messageMedium={messageMedium} />
    </AudienceLiftWrapper>
  );
};
